import { render } from "./BlogCategoryLabel.vue?vue&type=template&id=8f019496&scoped=true"
import script from "./BlogCategoryLabel.vue?vue&type=script&lang=js"
export * from "./BlogCategoryLabel.vue?vue&type=script&lang=js"

import "./BlogCategoryLabel.vue?vue&type=style&index=0&id=8f019496&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f019496"]])

export default __exports__